export const FAVORITE_LIST_ENTITY_NAME = 'Favorites';
